import { subscriptionsAdminIframeApp } from '../apps/Applications';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  ModalHost
} = subscriptionsAdminIframeApp;

/* @deprecated use subscriptionsAdminIframeApp.ModalHost instead
 * This is a shim for currently in use Subscription Admin app
 * This can be removed when line item card and subscription action is updated
 * to use the new version */
export function EditSubscriptionModal({
  subscriptionId,
  isOpen,
  onClose
}) {
  return /*#__PURE__*/_jsx(ModalHost, {
    isOpen: isOpen,
    onClose: closedPayload => onClose(closedPayload),
    initializeArgs: {
      subscriptionId
    }
  });
}